<template>
  <article class="component-content component-settings">
    <div class="content">
    <section class="content__title">
      <h2 class="text" v-text="$t('Settings.dialogTitle')"/>
    </section>
    <section class="content__item">
      <h3 class="label" v-text="$t('Settings.titles.name')"/>
      <p class="text" v-text="name"/>
    </section>
    <section class="content__item">
      <h3 class="label" v-text="$t('Settings.titles.trialStart')"/>
      <p class="text" v-text="trialStart" />
    </section>
    <section class="content__item">
      <h3 class="label" v-text="$t('Settings.titles.trialEnd')"/>
      <p class="text" v-text="trialEnd" />
    </section>
    <hr class="content__divider"/>
    <section class="content__list">
      <ul class="link-list">
        <li class="link-list__item">
          <button
            @click="$emit('navigate',{name: 'Viewer', query: { page: 'tos' } })"
            class="dv-button dv-button--invisible link">
            {{ $t('linkTitles.tos') }}
          </button>
        </li>
        <li class="link-list__item">
          <button
            @click="$emit('navigate', {name: 'Viewer', query: { page: 'privacy' } })"
            class="dv-button dv-button--invisible link">
            {{ $t('linkTitles.privacy') }}
          </button>
        </li>
        <li class="link-list__item">
          <WrappedLink
            class="link"
            external
            to="mailto:help@myscsjourney.com?subject=Feedback from mySCS (Web)">
            {{ $t('actions.sendFeedback') }}
          </WrappedLink>
        </li>
      </ul>
    </section>
    <section class="content__buttons">
      <button
        @click="$emit('done')"
        class="dv-button dv-button--secondary dv-button--large">
        {{ $t("actions.done") }}
      </button>
    </section>
    </div>
  </article>
</template>
<script>
import WrappedLink from '@components/WrappedLink'
export default {
  name: 'Settings',
  components: {
    WrappedLink
  },
  props: {
    name: {
      type: String,
      required: true
    },
    trialStart: String,
    trialEnd: String
  }
}
</script>
<style scoped lang="scss">
  .component-settings {
    width: 840px;
    padding: 40px;
    .content {
      &__title {
        .text {
          font-size: 36px;
          font-weight: bold;
          color: $textColor;
          margin: 0;
        }
      }
      &__item {
        margin-top: 32px;
        font-family: $themeMainFont;
        .label {
          margin: 0;
          font-size: 18px;
          font-weight: bold;
          color: $smokyGrey;
          text-transform: uppercase;
        }
        .text {
          margin: 10px 0 0;
          font-size: 24px;
          color: $secondaryTextColor;
        }
      }
      &__divider {
        margin-top: 32px;
        border-color: $mediumDarkGrey;
      }
      &__list {
        margin-top: 32px;
        .link-list {
          margin: 0;
          padding: 0;
          list-style: none;
          &__item {
            &:not(:first-of-type) {
              margin-top: 32px;
            }
            .link {
              font-size: 21px;
              line-height: 1;
              font-weight: bold;
              text-decoration: none;
              color: $textColor;
              font-family: $themeMainFont;
            }
          }
        }
      }
      &__buttons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        .dv-button {
          font-weight: bold;
        }
      }
    }
  }
</style>
